import { ComponentIds, GuestConnectionsComponent, HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import {
  getFrontsOnFrame,
  getFrontsInScene,
  getMajorityDesign,
  createFrontLayoutEntityWithDesign,
  createDefaultFrontLayoutEntity,
  getMajorityProduct
} from '../../shared/utils/frontLayouts';
import { getInteriorsInLoftBedDesk } from '../utils/loftbed';

const addFrontLayoutToLoftBed = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  },
  props
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  const frontLayoutProduct = products.find(
    product => product.coreProductId === props.coreProductId
  );
  if (!selectedEntity || !frontLayoutProduct) return;

  const frontEntitesOnFrame = getFrontsOnFrame(selectedEntity);
  const frontEntitesInScene = getFrontsInScene(coreApi);

  const previousFrontDesign =
    frontEntitesOnFrame.length > 0
      ? getMajorityDesign(frontEntitesOnFrame)
      : getMajorityDesign(frontEntitesInScene);

  const currentDrawersInDesk = getInteriorsInLoftBedDesk(selectedEntity);
  const handles = currentDrawersInDesk.flatMap(drawer =>
    HierarchyUtils.descendants(drawer).filter(child =>
      child.hasComponent(ComponentIds.HANDLE_COMPONENT_ID)
    )
  );
  const handleToAdd = getMajorityProduct(handles);
  coreApi.entities.deleteMultiple(currentDrawersInDesk);

  const frontLayoutEntity = previousFrontDesign
    ? createFrontLayoutEntityWithDesign(
        frontLayoutProduct,
        selectedEntity,
        products,
        coreApi,
        previousFrontDesign
      )
    : createDefaultFrontLayoutEntity(frontLayoutProduct, selectedEntity, products, coreApi);

  if (frontLayoutEntity) {
    coreApi.placementService.snapToConnector(
      frontLayoutEntity,
      'front-layout-frame',
      selectedEntity,
      'desk-center'
    );
    coreApi.placementService.dissolveEntity(frontLayoutEntity);
    if (handleToAdd) {
      const currentDrawersInDesk = HierarchyUtils.children(selectedEntity).filter(child =>
        child
          .getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
          ?.highestPriorityConnection?.hostConnector.key.includes('desk-left-hole-series')
      );
      currentDrawersInDesk.forEach(drawer => coreApi.products.addToTarget(handleToAdd, drawer));
    }
  }
};

export default addFrontLayoutToLoftBed;
